import { CVEditingSection, FullCV } from '@cibli/shared';
import React from 'react';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface SummaryProps {
  summary: FullCV['summary'];
  onEdit?: (section: CVEditingSection) => void;
  headingColor?: string;
}

const Summary: React.FC<SummaryProps> = ({ summary, onEdit, headingColor }) => {
  const { t } = useCVTranslation();

  const handleEdit = () => {
    if (onEdit) {
      onEdit('summary');
    }
  };

  const editable = onEdit !== undefined;
  if (!summary && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="mb-2 p-2 m-2">
        <h2
          className="text-[11px] font-black uppercase tracking-widest mb-0.25"
          style={{ color: headingColor ?? '#000000' }}
        >
          {t('CV.summary')}
        </h2>
        <p className="text-[11px] text-black leading-relaxed text-justify">
          {summary || (editable ? t('CV.summaryEmptyPlaceholder') : '')}
        </p>
      </div>
    </EditableSection>
  );
};

export default Summary;
